import mountPrototypeData from "./prototypeMapData"
import exportFile from "./exportFile"
import directives from "../directive"
import parallelDownload from "./parallelDownload";
import uploader from 'vue-simple-uploader'

// 挂载全局枚举数据
const installPrototypeData = {
  name: 'prototypeData ',
  install
}

function install(Vue) {
  // 挂载字典数据
  mountPrototypeData(Vue)
  // const enumCommonData = JSON.parse(localStorage.getItem('enumCommonData') || "{}") //本地存储获取的枚举数据
  // Object.keys(prototypeData).forEach(key => {
  //   let getter = prototypeData[key]
  //   if (getter && typeof getter === 'function') {
  //     if (enumCommonData[key]) {
  //       Vue.prototype[key] = enumCommonData[key]
  //     } else {
  //       getter(res => {
  //         if (!res) return
  //         Vue.prototype[key] = res
  //         enumCommonData[key] = res
  //         localStorage.setItem('enumCommonData', JSON.stringify(enumCommonData))
  //       })
  //     }
  //   } else {
  //     Vue.prototype[key] = getter
  //   }
  // })
  Vue.prototype.$export = exportFile;
  Vue.prototype.$parallelDownload = parallelDownload;
  Vue.use(uploader);
  directives.forEach(item => {
    Vue.use(item)
  })
}
export default installPrototypeData 